import { useState } from 'react';

import styles from '../../css/Contact.module.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { logAnalyticsEvent } = await import('../../utils/analyticsUtils');
    logAnalyticsEvent('contact_form_submit', {
      subject: formData.subject || 'No subject'
    });

    // Basic validation
    if (!formData.name || !formData.email || !formData.message) {
      setError('Please fill out all required fields');
      return;
    }

    const { sendContactMessage } = await import('../../firebase');
    const result = await sendContactMessage(formData.name, formData.email, formData.message);
    if (result.success) {
      setSubmitted(true);
      setError('');
    } else {
      setError(result.message);
    }
  };

  if (submitted) {
    return (
      <main className="mainContainer textCenteredOnMobile">
        <div className={`${styles.contactContainer} ${styles.centeredHorizontally}`}>
          <h1>THANK YOU</h1>
          <p style={{ paddingTop: "0.5rem", paddingBottom: "1rem" }}>Your message has been sent. We&apos;ll be in touch soon!</p>
          <button
            className={styles.submitButton}
            onClick={() => {
              setSubmitted(false);
              setFormData({
                name: '',
                email: '',
                subject: '',
                message: ''
              });
            }}
          >
            Send Another Message
          </button>
        </div>
      </main>
    );
  }

  return (
    <main className="mainContainer textCenteredOnMobile">
      <div className={styles.contactContainer}>
        <h1>CONTACT ME</h1>
        <p>Send me a message and I&apos;ll get back to you within a few days.</p>

        <form className={styles.contactForm} onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.labelText} htmlFor="name">Name*</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.labelText} htmlFor="email">Email*</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.labelText} htmlFor="subject">Subject</label>
            <input
              type="text"
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.labelText} htmlFor="message">Message*</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="3"
              required
            />
          </div>

          <button type="submit" className={styles.submitButton} disabled={submitted}>
            {submitted ? 'Sending...' : 'Send Message'}
          </button>
        </form>

        {error && <p className={styles.errorMessage}>{error}</p>}
      </div >
    </main >
  );
};

export default Contact;